import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';
import { enum as newsTypesEnum } from '../../../../enums/news-types';

import { REFETCH_ALL_DATA } from '../root';

import qs from 'qs';
import map from 'lodash/map';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import reduce from 'lodash/reduce';
import moment from 'moment';

import { create as paginationCreate } from '../shared/pagination';

const isRocket = process.env.CPA_ENV === 'rocket';

// see: enums/banner-campaigns
const bannerCampaignIds = isRocket ? [1, 2, 3] : [];

const pagination = paginationCreate('dashboard', {
	offers: {
		currentPage: 1,
		perPage: 3
	},
	topOffers: {
		currentPage: 1,
		perPage: 3
	},
	news: {
		currentPage: 1,
		perPage: 2
	}
});

// action types
const DATA_FETCH_SUCCESS = 'dashboard/data-fetch-success';
const DATA_FETCH_ERROR  = 'dashboard/data-fetch-error';
const DATA_CHART_FETCH_SUCCESS = 'dashboard/chart-fetch-success';
const DATA_CHART_FETCH_ERROR  = 'dashboard/chart-fetch-error';

const FETCH_NEWS_OFFERS_SUCCESS = 'dashboard/fetch-news-offers-success';
const FETCH_NEWS_OFFERS_ERROR = 'dashboard/fetch-news-offers-error';

const TOGGLE_NEWS = 'dashboard/toggle-news';

const CHANGE_ACTIVE_CURRENCY_FOR_OFFERS = 'dashboard/change-active-currency-for-offers';
const CLOSE_ON_START_POPUP_SUCCESS = 'dashboard/close-on-start-popup';
const CLOSE_ON_START_POPUP_ERROR = 'dashboard/close-on-start-popup';
const SET_QUID_ACTIVE = 'dashboard/set-quid-active';
const BANNERS_FETCH_SUCCESS = 'dashboard/banners-fetch-success';
const CONTEST_FETCH_SUCCESS = 'dashboard/contest-fetch-success';

// initialState state
const initialState = {
	data: null,
	error: false,
	pagination: pagination.initState,
	openedNewsId: null,
	openedNewsOffers: {},
	topOffers: {},
	offers: {
		maxItems: 15
	},
	charts: {
		data: {
			dayChart: null
		}
	},
	pollUrl: null,
	popups: {},
	currenciesForOffers: [],
	masterAccountDisplayStatsConfig: 'master_only',
	banners: {},
	contest: {
		count: 0
	}
};

// actions
export const actions = {
	fetchData: () => (dispatch, getState) => {
		const currency = getState().app.userData.activeBalance;
		const masterAccountDisplayStatsConfig = getState().dashboard.masterAccountDisplayStatsConfig;

		let urls = [
			endpoints.OFFERS.LIST,
			endpoints.NEWS.LIST,
			endpoints.PROFILE.MANAGER,
			endpoints.POLLS.BASE
		];
		let isForDay = false;

		if (process.env.CPA_ENV === 'everad') {
			urls.push(endpoints.POPUPS.BASE);
		}

		if (process.env.CPA_ENV === 'everad' || !window.globalConfig.isRocketBannerEnabled) {
			if (getState().routing.locationBeforeTransitions.pathname.indexOf('day-chart') > 0) {
				urls.push(getDayUrl(currency, masterAccountDisplayStatsConfig));
				isForDay = true;
			} else {
				urls.push(getWeekUrl(currency, masterAccountDisplayStatsConfig));
			}
		}

		const request = http({
			url: urls,
			method:'get',
			actions:[
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			],
			addToResponse: { isForDay }
		});

		request(dispatch)
			.then(() => {
				if (bannerCampaignIds.length) {
					const lang = getState().app.userData.general.language;
					http({
						url: bannerCampaignIds.map((campaignId) => (
							`${endpoints.BANNERS.BY_CAMPAIGN}?campaignId=${campaignId}&lang=${lang}`
						)),
						method: 'get',
						actions: [BANNERS_FETCH_SUCCESS, DATA_FETCH_ERROR],
						addToResponse: { bannerCampaignIds }
					})(dispatch);
				}
			})
			.then(() => {
				if (isRocket) {
					http({
						url: 'v2/profile/contest-statistics',
						method: 'get',
						actions: [CONTEST_FETCH_SUCCESS, DATA_FETCH_ERROR]
					})(dispatch);
				}
			});
	},

	toggleNews: (index, id) => (dispatch, getState) => {
		const openedId = getState().dashboard.openedNewsOffers.id;

		if (openedId != id) {
			const request = http({
				url: [`${endpoints.NEWS.LIST}/${id}`],
				method: 'get',
				actions: [FETCH_NEWS_OFFERS_SUCCESS, FETCH_NEWS_OFFERS_ERROR]
			});
			dispatch(request).then(action => {
				dispatch({
					type: TOGGLE_NEWS,
					payload: index
				});
			});
		} else {
			dispatch({
				type: TOGGLE_NEWS,
				payload: index
			});
		}
	},

	closeOpenedNews: () => dispatch => {
		dispatch({
			type: TOGGLE_NEWS,
			payload: ''
		});
	},

	pagination: () => dispatch => pagination.actions(dispatch),

	onChartsSwitch: (path, masterAccountDisplayStatsConfig) => (dispatch, getState) => {
		const currency = getState().app.userData.activeBalance;
		masterAccountDisplayStatsConfig =
			masterAccountDisplayStatsConfig || getState().dashboard.masterAccountDisplayStatsConfig;

		const isForDay = path == 'dashboard/day-chart/';
		const url = isForDay ?
			getDayUrl(currency, masterAccountDisplayStatsConfig) :
			getWeekUrl(currency, masterAccountDisplayStatsConfig);

		const request = http({
			url,
			method:'get',
			actions: [DATA_CHART_FETCH_SUCCESS, DATA_CHART_FETCH_ERROR],
			addToResponse: { isForDay, masterAccountDisplayStatsConfig }
		});
		request(dispatch);
	},

	onTypeSwitch: newConfig => (dispatch, getState) => {
		const state = getState();
		const route = state.routing.locationBeforeTransitions
			&& state.routing.locationBeforeTransitions.pathname.slice(1);
		dispatch(actions.onChartsSwitch(route, newConfig));
	},

	changeActiveCurrency: (currency, id) => ({
		type: CHANGE_ACTIVE_CURRENCY_FOR_OFFERS,
		payload: {currency, id}
	}),

	setQuidActive: id => ({
		type: SET_QUID_ACTIVE,
		payload: id
	}),

	closeOnStartPopup: (popup) => (dispatch) => {
		const request = http({
			url: `${endpoints.POPUPS.CLOSE_ON_START}?popup=${popup}`,
			method: 'post',
			actions: [CLOSE_ON_START_POPUP_SUCCESS, CLOSE_ON_START_POPUP_ERROR]
		});
		request(dispatch);
	}
};

// reducers
const reducers = Object.assign({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const [ offers, news, manager, pollUrl, popups, someChart ] = action.payload.map(res => res.data);
		const orderedOffers = offers && offers.length ? orderBy(offers, o => o.new_until || o.created_at, 'desc') : [];
		const topOffers = orderedOffers.filter(off => off.is_top_offer).slice(0, state.offers.maxItems);
		return {
			...state,
			data: {
				offers: offers && map(orderedOffers.slice(0, state.offers.maxItems), o => {
					if (o.payouts) {
						o.payouts = o.payouts.sort((a, b) => +(a.currency > b.currency) || +(a.currency === b.currency) - 1);
					}
					return o;
				}),
				topOffers: offers && map(topOffers, o => {
					if (o.payouts) {
						o.payouts = o.payouts.sort((a, b) => (a, b) => a === 'rub' ? -1 : 0);
					}
					return o;
				}),
				news,
				manager
			},
			charts: {
				...state.charts,
				data: {
					...state.charts.data,
					weekChart: action.meta.isForDay ? state.charts.data.weekChart : prepareWeekDataForCharts(someChart),
					dayChart: action.meta.isForDay ? prepareDayDataForCharts(someChart) : state.charts.data.dayChart
				}
			},
			pollUrl,
			popups
		};
	},
	[BANNERS_FETCH_SUCCESS]: (state, action) => {
		return {
			...state,
			banners: reduce(action.payload.map(res => res.data), (acc, value, i) => ({
				...acc,
				[action.meta.bannerCampaignIds[i]]: value
			}), {})
		};
	},
	[CONTEST_FETCH_SUCCESS]: (state, action) => {
		return {
			...state,
			contest: action.payload.data
		};
	},
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[FETCH_NEWS_OFFERS_SUCCESS]: (state, action) => {
		const [data] = action.payload.map(res => res.data);
		return { ...state, openedNewsOffers: data };
	},
	[DATA_CHART_FETCH_SUCCESS]: (state, action) => {
		const someChart = action.payload.data;
		return {
			...state,
			charts: {
				...state.charts,
				data: {
					...state.charts.data,
					weekChart: action.meta.isForDay ? state.charts.data.weekChart : prepareWeekDataForCharts(someChart),
					dayChart: action.meta.isForDay ? prepareDayDataForCharts(someChart) : state.charts.data.dayChart
				}
			},
			masterAccountDisplayStatsConfig: action.meta.masterAccountDisplayStatsConfig
		};
	},
	[DATA_CHART_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[TOGGLE_NEWS]: (state, action) => {
		return { ...state, openedNewsId: action.payload === state.openedNewsId ? null : action.payload };
	},
	[CHANGE_ACTIVE_CURRENCY_FOR_OFFERS]: (state, action) => {
		const data = state.currenciesForOffers;
		const existing = findIndex(data, { id: action.payload.id });
		if (existing < 0) {
			data.push(action.payload);
		} else {
			data[existing] = action.payload;
		}
		return {
			...state,
			currenciesForOffers: data
		};
	},
	[SET_QUID_ACTIVE]: (state, action) => {
		const data = [...state.currenciesForOffers];
		const existingIndex = findIndex(data, { id: action.payload});
		data[existingIndex < 0 ?  data.length : existingIndex] = {id: action.payload, currency: 'Q'};
		return {
			...state,
			currenciesForOffers: data
		};
	},
	[CLOSE_ON_START_POPUP_SUCCESS]: (state, action) => {
		return {
			...state,
			popups: {...state.popups, [action.payload.data.popup]: {}}
		};
	},
	[REFETCH_ALL_DATA]: () => initialState

}, pagination.reducers);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.dashboard.data,
	getUserData: state => state.app.userData,
	getOffers: state => pagination.selectors.getPageData(
		state => state.dashboard.data && state.dashboard.data.offers,
		state => state.dashboard.pagination.offers.perPage,
		state => state.dashboard.pagination.offers.currentPage
	)(state),
	getTopOffers: state => pagination.selectors.getPageData(
		state => state.dashboard.data && state.dashboard.data.topOffers,
		state => state.dashboard.pagination.topOffers.perPage,
		state => state.dashboard.pagination.topOffers.currentPage
	)(state),
	getNews: state => pagination.selectors.getPageData(
		state => state.dashboard.data && groupNewsByDate(state.dashboard.data.news),
		state => state.dashboard.pagination.news.perPage,
		state => state.dashboard.pagination.news.currentPage
	)(state),
	getNewsTypesEnum: () => newsTypesEnum,
	getOpenedNewsId: state => state.dashboard.openedNewsId,
	getOpenedNewsOffers: state => state.dashboard.openedNewsOffers.news_offers,
	getManager: state => state.dashboard.data && state.dashboard.data.manager,
	getCharts: state => state.dashboard.charts,
	getCurrenciesForOffers: state => ({
		data: state.dashboard.currenciesForOffers,
		activeBalance: state.app.userData.activeBalance
	}),
	getBanners: state => state.dashboard.banners,
	getLandingLanguages: state => state.app.lists['landing-languages'] &&
		state.app.lists['landing-languages']
			.reduce((acc, value) => {acc[value.id] = value.text; return acc;}, {}),
	getPollUrl: state => state.dashboard.pollUrl,
	getPopups: state => state.dashboard.popups,
	getContest: state => state.dashboard.contest,
	getMasterAccountDisplayStatsConfig: state => state.dashboard.masterAccountDisplayStatsConfig,
	getIntl: state => intl(state),
	getError: state => state.dashboard.error
};

const getWeekUrl = (currency, masterAccountDisplayStatsConfig) => {
	const start = moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss.SSS');
	const end = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss.SSS');
	const query = qs.stringify({
		currency,
		date_range: {
			start, end
		},
		groups: ['date'],
		master_account_display_stats_setting: masterAccountDisplayStatsConfig
	});
	return `${endpoints.STATISTICS.GENERAL}?${query}`;
};

const getDayUrl = (currency, masterAccountDisplayStatsConfig) => {
	const start = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss.SSS');
	const end = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss.SSS');
	const query = qs.stringify({
		currency,
		date_range: {
			start, end
		},
		groups: ['hour'],
		master_account_display_stats_setting: masterAccountDisplayStatsConfig
	});
	return `${endpoints.STATISTICS.GENERAL}?${query}`;
};

function prepareWeekDataForCharts (data) {
	const dateRange = getLastSevenDaysDateRange();
	const daysData = map(dateRange, date => {
		const d = moment(date).get('date');
		const row = find(data, row => moment(row.date).get('date') == d);
		return row || {date: date, hosts: 0, accepted_conversions: 0, accepted_income: 0};
	});

	return daysData;
}

function prepareDayDataForCharts (data) {
	const hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
	const hoursData = map(hours, h => {
		const row = find(data, row => h == row.hour);
		return row || {hour: h, hosts: 0, accepted_conversions: 0, accepted_income: 0};
	});

	return hoursData;
}

const getLastSevenDaysDateRange = function() {
	const range = [];
	for (let i = 6; i >= 0; i--) {
		range.push(moment().subtract(i, 'days').format('YYYY-MM-DD'));
	}
	return range;
};

const groupNewsByDate = rows => {
	return map(
		groupBy(rows, row => moment(row.published_at).format('YYYY-MM-DD')),
		(value, key) => ({ 'date': key, 'news': value })
	);
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/index.js